import React from 'react'
import map from '../assets/map.png'
const Contact = () => {
  return (
    <div>
      <div>
             
        </div>


        <div className='divss'>
           <div>
             <h1 >Contact</h1>
             <h1 >Information</h1>
             <h1 >Company Name</h1>
            <h1  >1234 Sample Street Austin Texas 76401</h1>
            <h1  >512.333.2222</h1>
            <p >sampleemail@gmail.com</p>

            <button >CONTACT US</button>
           </div>
            <div >
                <img  src={map} alt="" />
            </div>
        </div>
    </div>
  )
}

export default Contact
